export interface SettingsFeatureFlags {
  overview: boolean;
  businessPaymentMethods: boolean;
  businessDeliveryTimings: boolean;
  businessServiceTypes: boolean;
  businessLiftTypes: boolean;
  businessVendors: boolean;
  businessStores: boolean;
  documentsTerms: boolean;
  accessUsers: boolean;
  accessPermissions: boolean;
  accessDevices: boolean;
  personalizationHomeLinks: boolean;
  personalizationDashboardButtons: boolean;
  personalizationButtonColors: boolean;
}

export const defaultSettingsFeatureFlags: SettingsFeatureFlags = {
  overview: true,
  businessPaymentMethods: true,
  businessDeliveryTimings: true,
  businessServiceTypes: true,
  businessLiftTypes: true,
  businessVendors: true,
  businessStores: true,
  documentsTerms: true,
  accessUsers: true,
  accessPermissions: true,
  accessDevices: true,
  personalizationHomeLinks: true,
  personalizationDashboardButtons: true,
  personalizationButtonColors: true,
};
